// extracted by extract-css-chunks-webpack-plugin
module.exports = {"layout":"blank-main__layout--2Ptxh","wrapper":"blank-main__wrapper--zHaE0","sidebar":"blank-main__sidebar--210XE","main":"blank-main__main--2U9w_"};